import React from "react"
import Helmet from "react-helmet"
import { Link } from "react-router"
import State from "../../stores/State"
import Icon from "../elements/Icon"
import { injectIntl, FormattedMessage } from "react-intl"
import contributeMessages from "../../messages/imageUpload"
import { getStyles, getStyleTag } from "../../styles/dynamicStyles"
import { isomorphicVars } from "../../scripts/isomorphicVars"

class Contribute extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      contributorId: State.get("userId")
    }
  }

  render() {
    const { authentic_account_id } = isomorphicVars()

    // If the user is on the manawatu heritage, show the specific Manawatu lead
    const isManawatuHeritageSite = authentic_account_id === 1
    const lead = isManawatuHeritageSite
      ? contributeMessages.leadManawatu
      : contributeMessages.lead

    return (
      <main id="main" role="main" tabIndex={0} data-article-style="page">
        {getStyleTag(["p-contribute__option__button"])}
        <Helmet title="Contribute" />
        <article className="c-article p-contribute" role="article">
          <header
            className="c-article__header"
            style={getStyles("c-article__header")}
          >
            <h1
              className="c-article__title"
              style={getStyles(["c-article__title", "contribute__title"])}
            >
              <FormattedMessage {...contributeMessages.contribute} />
            </h1>
          </header>

          <section className="c-article__content typography">
            <p className="lead" style={getStyles("contribute__content__lead")}>
              <FormattedMessage {...lead} />
            </p>

            <div className="p-contribute__options">
              <div
                className="p-contribute__option"
                style={getStyles("contribute__option")}
              >
                <Icon
                  icon="upload-media"
                  style={getStyles("contribute__icon")}
                />
                <h3 className="beta" style={getStyles("contribute__beta")}>
                  <FormattedMessage {...contributeMessages.media} />
                </h3>
                <p style={getStyles("contribute__description")}>
                  <FormattedMessage {...contributeMessages.haveArtifact} />
                </p>
                <Link
                  className="button p-contribute__option__button"
                  to="/upload-media"
                  style={getStyles("p-contribute__option__button")}
                >
                  <FormattedMessage {...contributeMessages.upload} />
                </Link>
              </div>
              <div className="p-contribute__option">
                <Icon
                  icon="image-alignment-inline"
                  style={getStyles("contribute__icon")}
                />
                <h3 className="beta" style={getStyles("contribute__beta")}>
                  <FormattedMessage {...contributeMessages.article} />
                </h3>
                <p style={getStyles("contribute__description")}>
                  <FormattedMessage {...contributeMessages.writeArticle} />
                </p>
                <Link
                  className="button p-contribute__option__button"
                  to="/write-article"
                  style={getStyles("p-contribute__option__button")}
                >
                  <FormattedMessage {...contributeMessages.write} />
                </Link>
              </div>
            </div>
          </section>
        </article>
      </main>
    )
  }

  componentDidMount() {
    this._stateListener = State.addListener(() => {
      const contributorId = State.get("userId")

      if (this.state.contributorId !== contributorId) {
        this.setState({
          contributorId: contributorId
        })
      }
    })
  }

  componentWillUnmount() {
    if (this._stateListener) {
      this._stateListener.remove()
    }
  }
}

export default injectIntl(Contribute)



// WEBPACK FOOTER //
// ./webapp/components/pages/Contribute.js